export default {
  "menu.organization.name.1" : undefined,
  "menu.organization.name.2" : undefined,
  "menu.organization.name.short" : undefined,
  "menu.about" : undefined,
  "menu.trails" : undefined,
  "menu.runners" : undefined,
  "menu.nearby" : undefined,
  "menu.nearby.short" : undefined,


  "about.description" : undefined,
  "about.noTrails" : undefined,

  "runners.title" : undefined,
  "runners.table.name" : undefined,
  "runners.table.trailsRan" : undefined,
  "runners.table.trailsHared" : undefined,

  "nearby.title" : undefined,

  "trailList.table.hares" : undefined,
  "trailList.table.pack" : undefined,

  "trail.when" : undefined,
  "trail.where" : undefined,
  "trail.hare" : undefined,
  "trail.pack" : undefined
}
